import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ProductEnum } from '@uc/web/shared/data-models';
import { ClearingUniversityCardComponent } from '@web/shared/ui';
import { ClearingCourseSearchUni } from '../../../models/clearing-course-search.models';
import { ClearingCourseCardContainerComponent } from '../clearing-course-card-container/clearing-course-card-container.component';
import { FeaturedClearingCourseComponent } from '../featured-clearing-course/featured-clearing-course.component';
import { SubjectKeyword } from '../../../models/course-search.models';

@Component({
	selector: 'uc-course-list-clearing',
	standalone: true,
	templateUrl: './course-list-clearing.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		FeaturedClearingCourseComponent,
		ClearingUniversityCardComponent,
		ClearingCourseCardContainerComponent,
	],
})
export class CourseListClearingComponent {
	subjectKeywords = input.required<SubjectKeyword[]>();
	unis = input.required<ClearingCourseSearchUni[]>();
	searchTerm = input.required<string>();

	readonly clearing = ProductEnum.Clearing;
}
